/**
 * FLICK-S: Karussell-Pfeile ausblenden, wenn es faktisch nichts zum Scrollen gibt.
 *
 * Hintergrund (2026-08-13, Philip, Runde 59): Seit die Produktlisten-Karussells (Runde 57/58)
 * dauerhaft sichtbare Pfeile haben, zeigte z.B. "Neu & Beliebt" (4 Artikel, aber 5 Spalten
 * eingestellt) trotzdem einen "Weiter"-Pfeil an - obwohl alle 4 Artikel bereits vollstaendig
 * sichtbar sind und es nichts zum Weiterscrollen gibt.
 *
 * URSACHE (in Shopifys eigener, mitgelieferter assets/slideshow.js - bewusst NICHT direkt
 * gepatcht, da Vendor-Datei/Theme-Update-Risiko): Die Komponente entscheidet "gibt es noch
 * mehr zum Scrollen" NICHT anhand des echten Scroll-Overflows, sondern anhand einer
 * IntersectionObserver-Schaetzung ("wie viele Slides gelten aktuell als sichtbar"). Bei
 * WENIGER Artikeln als eingestellten Spalten (hier 4 Artikel bei --column-count: 5) schaetzt
 * die Komponente die sichtbare Anzahl faelschlich zu niedrig und haelt den "Weiter"-Pfeil
 * faelschlich fuer aktiv, obwohl `slideshow-slides.scrollWidth` in Wahrheit exakt der
 * sichtbaren Breite entspricht (keine 1 Scroll-Pixel Differenz).
 *
 * FIX: Nach dem Laden (+ bei Groessenaenderung/Fenster-Resize, + bei Shopify-Section-
 * Neuladen im Theme-Editor) fuer jedes Produktlisten-Karussell den ECHTEN Scroll-Overflow
 * messen. Gibt es keinen (scrollWidth <= clientWidth, 1px Toleranz fuer Rundung), wird die
 * Klasse `flx-no-overflow` gesetzt - `assets/flicks-custom-v3.css` blendet dann die
 * komplette Pfeil-Leiste fuer dieses Karussell aus. Bei mehr Artikeln (echter Overflow)
 * bleibt alles wie gehabt unangetastet, Pfeile funktionieren normal inkl. der bestehenden
 * [disabled]-Logik am Zeilenanfang/-ende.
 */
(function () {
  function checkCarousels() {
    document.querySelectorAll('.resource-list__carousel').forEach(function (carousel) {
      var scroller = carousel.querySelector(':scope > slideshow-container > slideshow-slides');
      if (!scroller) return;
      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 1;
      carousel.classList.toggle('flx-no-overflow', !hasOverflow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCarousels);
  } else {
    checkCarousels();
  }

  window.addEventListener('load', checkCarousels);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkCarousels, 150);
  });

  // Theme-Editor: Section neu geladen/bearbeitet -> neu pruefen.
  document.addEventListener('shopify:section:load', checkCarousels);
  document.addEventListener('shopify:section:select', checkCarousels);

  // Bilder laden asynchron nach - Breite kann sich noch aendern, daher kurz nachpruefen.
  setTimeout(checkCarousels, 800);
  setTimeout(checkCarousels, 2000);
})();
